module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [((_vm.mode === 'business' && _vm.mondayDelivery) || (_vm.mode === 'private' && _vm.privateDeliveryDay === 'monday')) ? _c('div', {
    staticClass: "d-flex"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "order-summary__subscription__col-2"
  }, [_c('div', {
    staticClass: "order-result-summary overview"
  }, [_c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__text-container text-container"
  }, [(_vm.subscriptionType) ? _c('h4', [_vm._v(_vm._s(_vm.subscriptionType.name))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.interval('monday').name))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__baskets__list"
  }, _vm._l((_vm.sortedBasketsMonday), function(basket, index) {
    return _c('div', {
      key: ("monday-basket-" + index),
      staticClass: "order-result-summary__weight-container"
    }, [_c('span', {
      staticClass: "order-result-summary__weight-text"
    }, [_vm._v("\n                                " + _vm._s(basket.kg) + " kg\n                            ")])])
  }), 0)])]), _vm._v(" "), _vm._l((Object.keys(_vm.groupedBasketsExtra['monday'])), function(basketId, basketIndex) {
    return _c('div', {
      key: ("order-summary-monday-" + basketIndex),
      staticClass: "order-result-summary overview divider-2"
    }, [_c('div', {
      staticClass: "order-result-summary__col"
    }, [_c('div', {
      staticClass: "order-result-summary__text-container text-container"
    }, [_c('h4', [_vm._v(_vm._s(_vm.groupedBasketsExtra['monday'][basketId][0].name))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.getIntervals(_vm.groupedBasketsExtra['monday'][basketId][0].interval))), _c('br'), _vm._v("\n                                " + _vm._s(_vm.basketsExtraCount('monday', basketId, true)) + "x " + _vm._s(_vm.groupedBasketsExtra['monday'][basketId][0].unit) + "\n                            ")])])])])
  })], 2)]) : _vm._e(), _vm._v(" "), ((_vm.wednesdayDelivery && _vm.subscriptionType) || Object.keys(_vm.groupedBasketsExtra['wednesday']).length) ? _c('div', {
    staticClass: "d-flex"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "order-summary__subscription__col-2"
  }, [(_vm.wednesdayDelivery && _vm.subscriptionType) ? _c('div', {
    staticClass: "order-result-summary overview"
  }, [_c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__text-container text-container"
  }, [_c('h4', [_vm._v(_vm._s(_vm.subscriptionType.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.interval('wednesday').name))])])]), _vm._v(" "), _c('div', {
    staticClass: "order-result-summary__col"
  }, [_c('div', {
    staticClass: "order-result-summary__baskets__list"
  }, _vm._l((_vm.sortedBbasketsWednesday), function(basket, index) {
    return _c('div', {
      key: ("wednesday-basket-" + index),
      staticClass: "order-result-summary__weight-container"
    }, [_c('span', {
      staticClass: "order-result-summary__weight-text"
    }, [_vm._v("\n                                " + _vm._s(basket.kg) + " kg\n                            ")])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _vm._l((Object.keys(_vm.groupedBasketsExtra['wednesday'])), function(basketId, basketIndex) {
    return _c('div', {
      key: ("order-summary-wednesday-" + basketIndex),
      staticClass: "order-result-summary overview",
      class: {
        'divider-2': _vm.wednesdayDelivery
      }
    }, [_c('div', {
      staticClass: "order-result-summary__col"
    }, [_c('div', {
      staticClass: "order-result-summary__text-container text-container"
    }, [_c('h4', [_vm._v(_vm._s(_vm.groupedBasketsExtra['wednesday'][basketId][0].name))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.getIntervals(_vm.groupedBasketsExtra['wednesday'][basketId][0].interval))), _c('br'), _vm._v("\n                                " + _vm._s(_vm.basketsExtraCount('wednesday', basketId, true)) + "x " + _vm._s(_vm.groupedBasketsExtra['wednesday'][basketId][0].unit) + "\n                            ")])])])])
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-summary__subscription__col-1 text-container"
  }, [_c('h2', [_vm._v("Montagslieferung:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-summary__subscription__col-1 text-container"
  }, [_c('h2', [_vm._v("Mittwochslieferung:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-601b2f98","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/ResultsOverview.vue
// module id = 863
// module chunks = 0